(() =>{
"use strict";

  class Toggle {
      constructor(toggleBtn, toggleContent, id, text, breakpoint, start = false) {
				this.id = id;
        this.elts = {
          toggleBtn,
          toggleContent
        };
				this.mq = breakpoint ? window.matchMedia(`(min-width: ${breakpoint}px)`) : null;
				this.text = text;
        this.isOpen = false;
				this.isInit = false;
				this.start = start;
      }

      static setting = {
				transition: 500
      }

			static setBtnRole(el) {
				el.setAttribute('tabindex', '0');
				el.setAttribute('role', 'button');
		
				el.addEventListener('keydown', (e) => {
					if (e.key !== "Enter" && e.key !== ' ') return;
					e.preventDefault();
					el.click();
				});
			}

      init() {
				if(this.mq) {
					if (!this.mq.matches) {
						this.initBtn();
						this.initContent();
						this.isInit = true;
					} else {
						this.elts.toggleBtn.setAttribute('disabled', true);
					}

					this.onMediaChange();
				} else {
					this.initBtn();
					this.initContent();
				}
				
      }

			initBtn() {
				const btn = this.elts.toggleBtn;
				btn.setAttribute('aria-controls', this.id);
				btn.setAttribute('aria-expanded', `${this.start}`);
        btn.addEventListener('click', this.toggle.bind(this));

				if (this.text.open && this.text.close) {
					btn.setAttribute('aria-label', this.start ? this.text.close : this.text.open);
				}

				if (btn.nodeName !== 'BUTTON') {
					Toggle.setBtnRole(btn);
				}
			}

			initContent() {
				let style = `overflow: hidden; transition: height ${Toggle.setting.transition * 0.001}s, opacity ${Toggle.setting.transition * 0.001 }s, visibility ${Toggle.setting.transition * 0.001}s;`;

				if (!this.start) {
					style += 'height: 0;	visibility: hidden; opacity: 0;';
				}

				this.elts.toggleContent.style = style;
				this.isOpen = this.start;
			}

      toggle() {
				if (this.elts.toggleBtn.getAttribute('disabled')) {
					return;
				}

				if (this.isOpen) {
					this.close()
				} else {
					this.open()
				}
      }

      open() {
        this.elts.toggleContent.style.visibility = 'visible';
        this.elts.toggleContent.style.opacity = '1';
				this.elts.toggleContent.style.height = `${this.elts.toggleContent.scrollHeight}px`;
        this.elts.toggleBtn.setAttribute('aria-expanded', 'true');
        this.elts.toggleBtn.setAttribute('disabled', true);
				if (this.text.open && this.text.close) {
					this.elts.toggleBtn.setAttribute('aria-label', this.text.close);
				}
        this.isOpen = true;
        
        window.setTimeout(() => {
          this.elts.toggleContent.style.height = 'auto';
          this.restoreFocus();
        }, 500);
      }

      close() {
        this.elts.toggleContent.style.height = `${this.elts.toggleContent.scrollHeight}px`;

        window.setTimeout(() => {
          this.elts.toggleContent.style.visibility = 'hidden';
          this.elts.toggleContent.style.height = '0';
          this.elts.toggleBtn.setAttribute('disabled', true);
          this.elts.toggleBtn.setAttribute('aria-expanded', 'false');
					if (this.text.open && this.text.close) {
						this.elts.toggleBtn.setAttribute('aria-label', this.text.open);
					}
          this.isOpen = false;

          window.setTimeout(() => {
            this.elts.toggleContent.style.opacity = '0';
            this.restoreFocus();
          }, 500);
        });
      }

      restoreFocus() {
        this.elts.toggleBtn.removeAttribute('disabled');
        const current = document.activeElement;
        if (!current || current === document.body || current.nodeName === 'MAIN') {
          this.elts.toggleBtn.focus({preventScroll: true});
        }
      }

			onMediaChange() {
				this.mq.addEventListener('change', () => {
					if (!this.mq.matches) {
						if (!this.isInit) {
							this.initBtn();
							this.initContent();
							this.isInit = true;
						}

						this.elts.toggleBtn.removeAttribute('disabled');
					} else {
						this.destroy();
					}
				});
			}

			destroy() {			
				if (!this.isOpen) {
					this.open();
				}
				this.elts.toggleBtn.setAttribute('disabled', true);
			}
  }

	/* *** */

	const toggleElts = document.querySelectorAll('.js-cm-toggle');

	toggleElts.forEach((elt) => {
		const toggleBtns = elt.querySelectorAll('[data-toggle]');
		toggleBtns.forEach((btn) => {
			const id = btn.getAttribute('data-toggle');
			const content = btn ? document.getElementById(id) : null;
		
			if (!content) {
				return;
			}
		
			const text = {
				open: btn.getAttribute('data-toggle-open'),
				close: btn.getAttribute('data-toggle-close')
			}

			const start = btn.getAttribute('data-toggle-start') ? true : false;
			const breakpoint = Number(btn.getAttribute('data-toggle-breakpoint')) ?  Number(btn.getAttribute('data-toggle-breakpoint')) : null;
	
			btn.removeAttribute('data-toggle');
			btn.removeAttribute('data-toggle-open');
			btn.removeAttribute('data-toggle-close');
			btn.removeAttribute('data-toggle-start');
			btn.removeAttribute('data-toggle-breakpoint');
			const toggle = new Toggle(btn, content, id, text, breakpoint, start);
			toggle.init();
		});
	});

	/* *** */

	const faqToggleElts = document.querySelectorAll('.tpl-page--faq .main-page-content dl');

	faqToggleElts.forEach((elt, i) => {
		const toggleBtn = elt.querySelector('dt');
		const toggleContent = toggleBtn ? toggleBtn.nextElementSibling : null
		if (!(toggleBtn && toggleContent)) return;

		const id = `toggle-faq-${i + 1}`;

		const text = {
			open: 'Open',
			close: 'Close'
		}

		const toggle = new Toggle(toggleBtn, toggleContent, id, text, null);
		toggle.init();
	});
})();